import { createAction, props } from '@ngrx/store';
import { IUser } from '../../types/auth/user';

export const login = createAction('[User] Login', props<{ user: IUser }>());

export const logout = createAction('[User] Logout');

//export const updateUserSession = createAction('[User] Update Session',props<{ session: string }>());